import { Popover } from 'bootstrap/dist/js/bootstrap.esm.min'

Array.from( document.querySelectorAll( '.wp-toolkit .popover' ) )
     .forEach( popoverNode => new Popover( popoverNode ) )
